import React, { useState } from 'react';
import InfoField from './InfoField';
import { FiEye } from 'react-icons/fi';
import PdfPreviewModal from '../../ClientModule/PdfPreviewModal';
import { getS3key } from '../../../services/employee/api';


const AddressDetailsSection = ({ title, addressData }) => {
  const [previewUrl, setPreviewUrl] = useState(null);
  const [previewType, setPreviewType] = useState(null);

  if (!addressData) {
    return (
      <div className="report-section">
        <h2 className="section-title">{title || 'Address Details'}</h2>
        <p>No address details available.</p>
      </div>
    );
  }

const handlePreview = async (fileKey) => {

  if (!fileKey) return;
  try {
    
    let file = fileKey.split(".com/")[1];
    file = decodeURIComponent(file);
    const response = await getS3key(file);
    const isPdf = file.toLowerCase().endsWith(".pdf");
    const blob = new Blob([response.data], {
      type: isPdf ? "application/pdf" : "image/jpeg"
    });
    const blobUrl = URL.createObjectURL(blob);
    setPreviewUrl(blobUrl);
    setPreviewType(isPdf ? "pdf" : "image");
  } catch (error) {
    console.error("Preview failed:", error);
  }
};

  // const verificationUrlsArray = Array.isArray(addressData.verificationUrls)
  //   ? addressData.verificationUrls
  //   : addressData.verificationUrls
  //     ? [addressData.verificationUrls]
  //     : [];

  return (
    <div className="admin-report-section">
      <h2 className="admin-section-title">
        {title || 'Address Details'}
      </h2>

      <div className="grid-container">
        <InfoField label="Address Line 1" value={addressData.addressLineOne || 'N/A'} />
        <InfoField label="Address Line 2" value={addressData.addressLineTwo || 'N/A'} />
        <InfoField label="Country" value={addressData.country || 'N/A'} />
        <InfoField label="State" value={addressData.state || 'N/A'} />
        <InfoField label="City" value={addressData.city || 'N/A'} />
        <InfoField label="Pincode" value={addressData.pincode || 'N/A'} />
        <InfoField label="Mobile Number" value={addressData.mobileNumber || 'N/A'} />

        
          <InfoField
            label="Address Verification File"
            value={
              <div className="file-preview-container">
                <button
                  className="preview-btn"
                  onClick={() => handlePreview(addressData.verificationUrls)}
                >
                  <FiEye className="preview-icon" /> View File
                </button>
              </div>
            }
          />
        
      </div>

{previewUrl && (
  <PdfPreviewModal
    fileUrl={previewUrl}
    fileType={previewType}
    onClose={() => setPreviewUrl(null)}
  />
)}
    </div>
  );
};

export default AddressDetailsSection;